import { COMPANY_CONFIG } from "companyConfig";
import { formatPhone } from "utils/formatPhone";

interface MemberServiceProps {
    number?: boolean;
    email?: boolean;
    titleClassName?: string;
}

export const MemberService = ({ titleClassName, number = true, email = true }: MemberServiceProps) => {
    return (
        <div data-testid="member-service">
            <p className={`text-sm font-bold ${titleClassName}`}>Member Services</p>
            {number && (
                <p className="text-xl font-semibold">
                    <a href={`tel:${COMPANY_CONFIG.number}`}>{formatPhone(COMPANY_CONFIG.number)}</a>
                </p>
            )}
            {email && (
                <p className="text-xl font-semibold">
                    <a href={`mailto:${COMPANY_CONFIG.email}`}>{COMPANY_CONFIG.email}</a>
                </p>
            )}
        </div>
    );
};
